import { useQuery, UseQueryResult } from 'react-query';
import { ConnectedAthlete } from 'types';
import { client } from 'utils/api-client';

export default function useConnectedAthletes(
  athleteId: string,
): UseQueryResult<{ data: ConnectedAthlete[] }> {
  return useQuery(
    ['connectedAthletes', athleteId],
    () => client.get(`athletes/${athleteId}/connected-athletes/`),
    {
      enabled: !!athleteId,
    },
  );
}
